// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1KbqM","list":"styles_list__30jtA"};